import { render, staticRenderFns } from "./ConfigScene.vue?vue&type=template&id=7bb649d6&scoped=true&"
import script from "./ConfigScene.vue?vue&type=script&lang=js&"
export * from "./ConfigScene.vue?vue&type=script&lang=js&"
import style0 from "./ConfigScene.vue?vue&type=style&index=0&id=7bb649d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb649d6",
  null
  
)

export default component.exports